import { render, staticRenderFns } from "./SupplierStockMindestmenge.vue?vue&type=template&id=2959fc0b&"
import script from "./SupplierStockMindestmenge.vue?vue&type=script&lang=js&"
export * from "./SupplierStockMindestmenge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports